import Onboarding from 'app/ui-components/Onboarding/Onboarding';
import styled, { css } from 'styled-components';
import { device } from '../../ui-components/breakpoints';
import Progressbar from '../../ui-components/Progressbar/Progressbar';
import PlayText from '../../ui-components/typography/PlayText/PlayText';

export const StyledDetailsPage = styled.div``;

export const MoreDetails = styled.div`
    @media ${device.GteSmall} {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
`;

const getPadding = (position) => {
    const marginSmall = '20px';
    const marginLarge = '30px';

    if (position === 'left') {
        return css`
            padding: ${marginSmall} 0 0 0;

            @media ${device.GteSmall} {
                padding: ${marginSmall} ${marginSmall} 0 0;
            }

            @media ${device.GteLarge} {
                padding: ${marginLarge} ${marginLarge} 0 0;
            }
        `;
    }

    return css`
        @media ${device.GteSmall} {
            padding: ${marginSmall} 0 0 0;
        }

        @media ${device.GteLarge} {
            padding: ${marginLarge} 0 0 ${marginLarge};
        }
    `;
};

const getWidth = (position) => {
    if (position === 'left') {
        return css`
            width: 100%;

            @media ${device.GteSmall} {
                width: calc((100% / 4) * 3);
            }

            @media ${device.GteMedium} {
                width: calc((100% / 5) * 3);
            }

            @media ${device.FullScreen} {
                width: 50%;
            }
        `;
    }

    return css`
        width: auto;
        @media ${device.GteSmall} {
            width: calc(((100% / 4) * 1));
        }

        @media ${device.GteMedium} {
            width: calc(((100% / 5) * 2));
        }

        @media ${device.FullScreen} {
            width: 50%;
            max-width: 460px;
        }
    `;
};

export const DetailArea = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    ${(props) => getPadding(props.position)}
    ${(props) => getWidth(props.position)}

    @media ${device.GteLarge} {
        &:nth-child(3) {
            padding-top: 30px;
        }
    }

    @media ${device.FullScreen} {
        &:nth-child(3) {
            padding-top: 20px;
        }
    }
`;

export const Description = styled(PlayText)`
    line-height: 1.4;
`;

export const ContentWarning = styled(PlayText)`
    margin-top: 15px;
`;

export const StyledProgressBar = styled(Progressbar)`
    padding: 0;

    & span {
        margin-top: 0;
    }
`;

export const StyledOnboarding = styled(Onboarding)`
    margin-bottom: -10px;
    margin-top: 15px;
`;
